import { Extension } from "@tiptap/core"
import { Plugin } from "@tiptap/pm/state"

/**
 * Overrides the default behavior for (atomic?) NodeViews, which is to
 * node-select them when clicked on.
 * Instead clicking should only interact with the NodeView.
 */
export const ExtensionWidgetClickSuppression = Extension.create({
  name: "widgetClickSuppression",

  addProseMirrorPlugins() {
    return [
      new Plugin({
        props: {
          handleClickOn(_view, _pos, node) {
            if (node.type.isInGroup("widget")) return true
            return false
          },
          handleDoubleClickOn(_view, _pos, node) {
            if (node.type.isInGroup("widget")) return true
            return false
          },
          handleTripleClickOn(_view, _pos, node) {
            if (node.type.isInGroup("widget")) return true
            return false
          },
        },
      }),
    ]
  },
})
